import { render, staticRenderFns } from "./InformacionEmpleado.vue?vue&type=template&id=087e43ed&scoped=true"
import script from "./InformacionEmpleado.vue?vue&type=script&lang=js"
export * from "./InformacionEmpleado.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "087e43ed",
  null
  
)

export default component.exports